import React, { Component } from "react";
// reactstrap components
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Row,
  Col,
  Button,
} from "reactstrap";
import {
  Link
} from "react-router-dom";


import ConnectorService from '../../services/api/Connector'; 
import ScaleLoader from "react-spinners/ScaleLoader";
import LoadingOverlay from 'react-loading-overlay';
import { Scrollbars } from 'react-custom-scrollbars';
import { CONNECTOR_BASE_URL } from "settings/shared/constants";

// core components
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import { uuidv4 } from '../../components/Notebook/operations/notebook';
import axios from "axios";

class Connectors extends Component {
  constructor(props) {
    super(props);
    this.state = {
      connectorDTOS:[],
      swidth: window.innerWidth,
      sheight: window.innerHeight 
    }
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);

  }
  componentDidMount() {
    this.GetAllConnectors();
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
 }
  
 componentWillUnmount() {
  window.removeEventListener('resize', this.updateWindowDimensions);
}

updateWindowDimensions() {
  this.setState({ swidth: window.innerWidth, sheight: window.innerHeight});
}
  // Edit Connector
  EditConnector = (id,name) =>{
    this.props.history.push({
      pathname: '/integration/NewConnection',
      state: { mode:"editConnector",editId:id,}
      })
  }
 

 GetAllConnectors  = () =>{
  this.setState({
    loading:true
  })
  ConnectorService.getAllConnectors()
  .then((response) => {
    if(response.connectorsDTOPage.content.length !== 0){
      this.setState({
        connectorDTOS:response.connectorsDTOPage.content,
        loading:false
      })
    }else{
      this.setState({
        connectorDTOS:[],
        loading:false
      })
    }
  }).catch((error) => {
    this.setState({ loading:false });
  })
 }
 
 getConnnectorIcon = (iconPath) => {
  return CONNECTOR_BASE_URL + iconPath.replace(".", "/") + "/icon.png"
  }

  
  render() {
    return (
   
      <>
        <PanelHeader
          content={
            <div className="header text-center">
            
            </div>
          }
        />
        <div className="content">
        <LoadingOverlay
      active={this.state.loading}
      spinner={<ScaleLoader
        height={35}
        width={5}
        radius={2}
        margin={2}
        color={"#123abc"}
        loading={this.state.loading}
      />}
    >
          <Row>
            <Col xs={12} md={12}>
              <Card>
                <CardHeader>
                <Row className="align-items-center">
                <div className="col">
                  <CardTitle tag="h5">Active Connectors</CardTitle>
                 </div>
                 <div className="col text-right">
                 <Link to={{
                        pathname: '/integration/connectors'
                      }}> 
                      <span> <i className="fas fa-sync-alt mr-3" onClick={e =>this.GetAllConnectors()}/></span>
                       </Link>
                       {/* <Link to={{
                        pathname: '/connectors/NewConnection',
                        state: { mode:"addnew" }
                      }}> */}
                         <Link to={{
                        pathname: '/integration/CreateConnection',
                        state: { mode:"addnew" }
                      }}>
                         
                         <Button
                        color="primary"
                        href=""
                        size="sm"
                      >
                      Create Connectors
                      </Button>
                      </Link>
                    </div>
                </Row>
                  
                </CardHeader>
                {/* <Scrollbars autoHeight autoHeightMin={650} autoHeightMax={650}> */}
                <CardBody>
                <div className="carcontent">
                <Scrollbars autoHeight autoHeightMin={this.state.sheight-220}>

            <Row className="mt-12">
              <Col className="mb-12 mb-xl-0" xl="12">
                <div className="table-responsive">
                    <Row className="icon-examples" style={{marginTop:10}}>
                      {this.state.connectorDTOS.map((item, index) => (<Col sm={2} xs={12} key={uuidv4()}  className="gridSize_Connector" >
                        <Col className="text-center" lg="12" md="12" onClick={e => {e.preventDefault()
                        this.EditConnector(item.id,item.name)}}>
                        <div className="grid-Connector card">
                        {item.enable === true && 
                        <div className="img-active">
                        <img src={this.getConnnectorIcon(item.connectorType)} alt="ConnectorImage" title="Enabled"/>
                        <i className="fas fa-check-circle" title="Enabled"></i>
                        <div className="grid-desc">{item.name}</div>                       
                        </div>  
                       }
                       {item.enable === false && 
                        <div className="img-deactive">
                        <img src={this.getConnnectorIcon(item.connectorType)} alt="ConnectorImage" title="Disabled"/>
                        <div className="grid-desc condisabled">{item.name}</div>

                       </div>
                      }
                        </div>
                        </Col>
                      </Col>))}
                      {this.state.connectorDTOS.length === 0 && <Col>
                        <div style={{ justifyContent: "center", textAlign: "center" }}>
                          <span>No Connectors Found</span>
                        </div>
                      </Col>
                      }
                      
                    </Row>
              
                </div>  
              </Col>
            </Row>
            </Scrollbars>

             </div>
              </CardBody>
              {/* </Scrollbars> */}
              </Card>
            </Col>
          </Row>
          </LoadingOverlay>

        </div>
      </>
    );
  }
}

export default Connectors;

